Ext.define('SA.model.LocationValue.String', {
    extend: 'SA.model.LocationValue',

    statics: {
        isConformantValue(value) {
            return SA.model.CustomLocationStringId.match(value) || SA.model.LocationSeriesString.match(value);
        }
    },

    getId() {
        if (SA.model.CustomLocationStringId.match(this.value)) {
            return SA.model.CustomLocationStringId.getInteger(this.value);
        }

        return this.value;
    },

    toItem() {
        if (SA.model.LocationSeriesString.match(this.value)) {
            return {type: 'locationSeries', id: this.value};
        }

        return this.callParent();
    },

    toString() {
        return this.value;
    }
});